import React from 'react';
import './CreateDrugBoxCard.css';
import Card from '../../../components/card/Card';
import Label from '../../../components/label/Label';
import Input from '../../../inputs/input/Input';
import Button from '../../../components/button/Button';
import FormTemplate from '../../../components/templates/formTemplates/FormTemplate';
import toasts from '../../../utils/toasts';
import models from '../../../model/models';
import FontIcon from '../../../components/fontIcon/FontIcon';
import mainAPI from "../../../api/MainAPI";
import UniversalDropDown from "../../../components/universalDropDown/UniversalDropDown";

export default class CreateDrugBoxCard extends FormTemplate {
	_create = async () => {
		if (!this.isValid()) return toasts.show('Fill out required fields');
		let value = this.getValue();
		if (value.barcode_id.length <= 3) {
			return toasts.show('Code must be longer than 3 characters');
		}
		if (/\s/.test(value.barcode_id)) {
			return toasts.show('Spaces are not allowed drug or box codes', 3000);
		}
    let drug = await mainAPI.drug.find_by_barcode({ barcode_id: value.barcode_id });

    if (drug) return toasts.show(`(${value.barcode_id}) already in use by drug`);
		let drugBox = await models.drug_box.save(value);
		this.props.onCreate(drugBox.id);
	};

	render() {
		return (
			<Card className="g-create-drug-box-card">
				<Label black larger>
					Create Drug Box
				</Label>
        <div className="close-popup">
          <FontIcon
            tabIndex="0"
            onClick={this.props.onClose}
            name="icon-cancel"
            color="white"
          />
        </div>
				<Label gray-medium>Code</Label>
				<Input required ref={(ref) => (this.myRefs.barcode_id = ref)} />
				<Label gray-medium>Name</Label>
				<Input length={15} required ref={(ref) => (this.myRefs.name = ref)} />
				<Label gray-medium>Unit</Label>
				<UniversalDropDown
					ref={ref=>this.myRefs.unit_id = ref}
					required
					endpoint={mainAPI.unit.all}
				/>
				<Button center bg="blue" color="white" onClick={this._create}>
					Save
				</Button>
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/unitListPage/createDrugBoxCard/CreateDrugBoxCard.jsx